import { render, staticRenderFns } from "./Index-Login.vue?vue&type=template&id=35f427b4&scoped=true"
import script from "./Index-Login.vue?vue&type=script&lang=js"
export * from "./Index-Login.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f427b4",
  null
  
)

export default component.exports